<template>
<div>
  <el-dialog
      title="历史操作记录"
      :visible.sync="showHistoryDia"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      show-close>
      <el-table
        :data="historyListData"
        border
        height="400">
        <el-table-column
          prop="createTime"
          width="140"
          label="时间">
          <template slot-scope="scope">
            <div v-if="scope.row.createTime !=0 && scope.row.createTime !=null">
              {{scope.row.createTime | FormatDate('yyyy-MM-dd hh:mm') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="oprType"
          label="操作类型"
          width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.oprType == 100"
                 style="padding:4px 8px;background:#5cb85c;color:#fff;text-align: center;border-radius: 4px;">新增
            </div>
            <div v-if="scope.row.oprType == 200"
                 style="padding:4px 8px;background:#2E8BFF;color:#fff;text-align: center;border-radius: 4px;">修改
            </div>
            <div v-if="scope.row.oprType == 300"
                 style="padding:4px 8px;background:#5bc0de;color:#fff;text-align: center;border-radius: 4px;">审核
            </div>
            <div v-if="scope.row.oprType == 400"
                 style="padding:4px 8px;background:#f0ad4e;color:#fff;text-align: center;border-radius: 4px;">接诊
            </div>
            <div v-if="scope.row.oprType == 500"
                 style="padding:4px 8px;background:#337ab7;color:#fff;text-align: center;border-radius: 4px;">诊断
            </div>
          </template>
        </el-table-column>
         <el-table-column
          prop="oprContent"
          label="操作内容">
        </el-table-column>
        <el-table-column
          prop="createUsrType"
          label="处理用户类别"
          width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.createUsrType == 100">小程序</div>
            <div v-if="scope.row.createUsrType == 200">项目经理</div>
            <div v-if="scope.row.createUsrType == 300">销售</div>
            <div v-if="scope.row.createUsrType == 400">专家</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createUsrRealname"
          label="操作人"
          width="140">
        </el-table-column>
      </el-table>
    </el-dialog>
</div>
</template>

<script>
import PageNation from "./PageNation";
import ApiService from "../../service/ApiService";
import pub from "../../service/public";
export default {
  name: "OperationRecord",
  components:{
    PageNation:PageNation,
  },
  data(){
    return{
      historyListData: [],
      showHistoryDia:false,
      operationType:[],
    }
  },
  methods:{
    getHistoryOperation(item){
      this.historyListData = [];
      let params = {
        page:{
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          heartRecvId:item.heartRecvId,
        }
      };
      ApiService.HeartOrderOprLogList(params).then(res => {
					this.loading = false;
					if (res.code == 0) {
						this.historyListData = res.data.pageList;
					} else if (res.code == 204) {
            pub.refresh(this.getHistoryOperation(item));
          } else {
            pub.analysisReturnCode(res);
          }
				}).catch(error => {
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					this.loading = false;
					console.log("操作记录列表报错信息：", error);
				});
    },
    showOperationListDia(item){
      this.showHistoryDia = true;
      this.getHistoryOperation(item);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common/OperationRecord.vue